import React__default from 'react';

const Backdrop = ({ isShown, backgroundColor = 'light' }) => {
    let bg = 'rgba(0, 0, 0, 0.5)';
    if (backgroundColor === 'light')
        bg = 'rgba(255, 255, 255, 0.9)';
    const backdropStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: bg,
        zIndex: 9999, // Elements over 9999 will show over backdrop
        opacity: isShown ? '1' : '0',
        /*     pointerEvents: 'none', */
        transition: 'opacity 0.3s ease',
    };
    return (React__default.createElement("div", { style: { pointerEvents: isShown ? 'auto' : 'none' } },
        React__default.createElement("div", { className: "noselect", style: backdropStyle })));
};

export { Backdrop as default };
//# sourceMappingURL=Backdrop.js.map
